import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Typography from "@mui/material/Typography";
import { Grid, useTheme } from "@mui/material";
import { APPLICATION_TITLE } from "../sharedCode/metadata";
import { Copyright } from "./ApolloLogin";

interface AboutDialogProps {
    onClose: () => void;
}

export default function AboutDialog(props: AboutDialogProps): JSX.Element {
    const theme = useTheme();

    return (
        <Dialog open>
            <Grid container sx={{ p: 2 }}>
                <Grid container item xs={12} justifyContent={"center"}>
                    <Typography component="h1" variant="h6">
                        {APPLICATION_TITLE}
                    </Typography>
                </Grid>
                <Grid container item xs={12} sx={{ pt: 2 }}>
                    <Grid item flex={1}>
                        {Copyright()}
                    </Grid>
                </Grid>
                <Grid container item xs={12} justifyContent={"center"}>
                    <Button variant="contained" sx={{ m: 1 }} onClick={props.onClose}>
                        OK
                    </Button>
                </Grid>
            </Grid>
        </Dialog>
    );
}
